export default "__VITE_ASSET__d23f6e3d__"